import styled, { css } from 'styled-components'
import { rem, em } from 'polished'
import { Link } from 'react-router-dom'
import { SiteContainer, media } from 'core/layout'
import { colors, isDefaultThemeMode, duration, ease } from 'core/theme'

export const StyledBanner = styled.div`
  background-color: ${colors.secondary};
  min-height: ${rem(400)};
  height: 0;
  position: relative;

  @media (min-height: 800px) {
    min-height: ${rem(500)};
  }

  @media print {
    display: flex;
    flex-direction: column;
    height: 300px;
    overflow: hidden;

    & > div {
      &:first-child {
        flex: 1 1 auto;
      }

      &:not(:first-child) {
        flex: 0 0 auto;
        background-color: ${colors.secondary};
      }
    }
  }
`;

export const Container = SiteContainer.extend`
  height: 100%;
  position: relative;

  & > div:first-child {
    margin: 0;
    height: 100%;
    position: relative;

    & > div {
      padding-top: 0;
    }

    ${media.site`
      & > div {
        flex-basis: 50%;
      }
    `};

    ${media.tablet`
      align-items: flex-start;
      justify-content: center;
      margin: 0;

      & > div {
        flex: auto;
        height: ${em(78)};
        padding-left: 0;
      }
    `};
  }
`

const imgBackgroundColor = props => (
  isDefaultThemeMode(props) ? colors.HIGHLIGHT : colors.background
)

export const ImgWrapper = styled.div`
  background-color: ${imgBackgroundColor};
  position: absolute;
  top: 0;
  left: 0;
  width: calc(50% + 209px); /* 209px = (370px (kartiņa) / 2) + 24px (gutter) */
  height: 100%;

  ${media.site`
    width: 50%;
  `};

  ${media.tablet`
    width: 100%;
    height: calc(100% - ${em(78)});
    top: ${em(78)} !important;
  `};

  @media print {
    position: static;
  }
`

const accessibilityHover = props => {
  if (!isDefaultThemeMode(props)) {
    return css`
      &:hover,
      &:active {
        background-color: ${colors.background};
        color: ${colors.text};
      }
    `
  }
}

const outlineColor = props => !isDefaultThemeMode(props) && css`
  &:focus {
    outline-color: ${colors.background};
  }
`

export const Content = styled.div`
  font-size: 2.25em;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  nav {
    flex: 0 0 auto;
  }

  ul {
    list-style: none;
    margin: 0;
    padding-left: 0;

    & > li + li {
      margin-top: 48px;
    }
  }

  ${media.tablet`
    font-size: 1.2em;

    ul {
      display: flex;
      margin-top: 1.25em;

      & > li + li {
        margin-top: 0;
      }
    }
  `};

  ${media.tabletSmall`
    font-size: 1em;
  `};

  ${media.mobile`
    font-size: 0.9em;
  `};

  @media print {
    a:after {
      color: ${colors.W};
    }

    li {
      margin: 0 1em;
    }
  }
`

export const FABposition = styled.div`
    position: absolute !important;
    bottom: 0;
    right: 0;
    height: auto !important;
    z-index: 51;

    & > button {
      transform: translateY(50%);
      ${outlineColor};

      & > * {
        pointer-events: none;
      }
    }

    ${media.tabletSmall`
      position: fixed !important;
      bottom: 8px;
      right: 8px;
      z-index: 200;

      & > button {
        transform: none;
      }
    `};
`

export const StyledLink = styled(Link)`
  font-weight: 500;
  padding: 0 0.5em;
  text-decoration: none;

  &,
  &:hover,
  &:active {
    color: ${colors.background};
  }

  & > i {
    margin-left: 0.25em;
    transition: transform ${duration.fast} ${ease.standard};
  }

  &:hover {
    text-decoration: underline;

    & > i {
      transform: translateX(20%);
    }
  }

  ${outlineColor};
  ${accessibilityHover};

  ${media.tablet`
    & > i {
      display: none;
    }
  `};
`



// WEBPACK FOOTER //
// ./src/pages/Sakums/components/Banner/styled.js